/* eslint-disable no-useless-escape */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import './index.css'
import { DesktopNavbar } from '../NavBar/Desktop/DesktopNavbar'
import {useState, useEffect} from 'react'
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { MobileNavbar } from '../NavBar/Mobile/MobileNavbar';
import { PageLogin } from '../LoginPage/PageLogin'

export const PageForgotPassword = () => {
    const [showNavPopup, setShowNavPopup] = useState(false)
    const [showLogin, setShowLogin] = useState(false)
    const [showRegister, setShowRegister] = useState(false)
    const [val1, setval1] = useState(false)

    const handleCloseAll = () => {
        setShowNavPopup(false)
    }

    useEffect(() =>{
        window.scrollTo(0, 0)
        localStorage.setItem('nav', 'u')
    },[])


    const [standby, setstandby] = useState(true)
    const [email, setEmail] = useState('')


    const history = useNavigate()



    useEffect(()=>{
        
        if(standby===false){
            setTimeout(function() {
                history('/')
           }, 500);
        }
    },[standby])

    const handleSubmit = e => {
        e.preventDefault()
        let isError=false
        var elem = document.getElementById("PFP1");
        if(email === ''){
            elem.className = "PUSform PUSred";
            isError=true
            setval1(true)
        }else{
            if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))){
                elem.className = "PUSform PUSred";
                isError=true
                setval1(true)
            }
            else{
                elem.className = "PUSform";
                setval1(false)
            }
        }
        if(isError){
            return
        }else{
            setstandby(false)
        }
    }
    
    
    return (
        <div onClick={e => {e.stopPropagation();handleCloseAll()}} id="maincontainer" style={{minWidth:"100%", minHeight:"100vh", backgroundColor:"#111111", position:"relative", overflow:"unset"}}>
            <DesktopNavbar showPopup={showNavPopup} setShowPopup={setShowNavPopup}></DesktopNavbar>
            <MobileNavbar></MobileNavbar>
            <CSSTransition in={standby} timeout={{appear:1000,enter:2000,exit:1000}} mountOnEnter={true} appear={true} classNames="MBPtrans">
            <div className='PFPkontainer'>
                <div className='PFPkonten'>
                    <p className='big bold white'>Reset your password</p>
                    <p className='white small PFPmargin'>Fill on your e-mail address below and we will send you a random password for login</p>
                    <form onSubmit={handleSubmit}>
                        <input id="PFP1" type='email' autoComplete='false' value={email} onChange={e => setEmail(e.target.value)} className='PUSform' placeholder='Enter your email'></input>
                        {
                            val1 && (
                                <p className='tiny red PUSval2'>Please fill your email correctly</p>
                            )
                        }
                        <button type="submit" className='bold small PUSmargin PFPbutton'>Send Me a Password</button>
                    </form>
                    <p className='white small PFPmiddle PFPmargin'>Alredy have account? <span onClick={() => setShowLogin(true)} className='PFPunderline bold'>Login here</span></p>
                    <p className='white small PFPmiddle PFPmargin2'>Don’t have account? <span onClick={() => setShowRegister(true)} className='PFPunderline bold'>Sign up here</span></p>
                </div>
            </div>
            </CSSTransition>
            {
                showRegister && (
                <PageLogin openRegister={true} fungsi={() => setShowRegister(false)}></PageLogin>
                )
            }

            {
                showLogin && (
                <PageLogin fungsi={() => setShowLogin(false)}></PageLogin>
                )
            }
        </div>
    )
  }